import type { ICarouselProps } from './Carousel';

async function MountCarousel(props: ICarouselProps, el: Element) {
	const module = await import('./Carousel');
	module.MountCarousel(props, el);
}
(window as any).MountCarousel = MountCarousel;
